import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import * as Config from '../../app/app.config';
import { AuthProvider } from '../auth/auth';
import { ProofProvider } from '../proof/proof';
import { MediaProvider } from '../../providers/media/media';
import { FileProvider } from '../../providers/file/file';

import { Storage } from '@ionic/storage';
import { Platform } from 'ionic-angular';
import { File } from '@ionic-native/file';
import { Transfer, FileUploadOptions, TransferObject } from '@ionic-native/transfer';

import { SendingStatus } from '../../models/sendingstatus';
import { MediaItem } from '../../models/mediaitem';

/*
  Generated class for the IdCardServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class IdCardServerProvider {

  // private medias: MediaItem[];
  // private mediasSuccess: any[];

  constructor(
    private http: Http,
    private auth: AuthProvider,
    // private proofProvider: ProofProvider,
    private storage: Storage,
    private platform: Platform,
    // private mediaProvider: MediaProvider,
    // private file: File,
    // private fileProvider: FileProvider
  ) {
    console.log('Hello IdCardServerProvider Provider');
  }

  // public contract(id: number) {
  //   let that = this;

  //   return Observable.create((observer: any) => {
  //     let headers = that.auth.createApplicationHeadersWithBearer();

  //     that.http.get(Config.baseUrl + '/quizz/contract/' + id, { headers: headers })
  //       .map((res: Response) => res.json())
  //       .subscribe((data) => {
  //         observer.next(data);
  //         observer.complete();
  //       }, (error: any) => {
  //         observer.error(new Error(error.status));
  //       });
  //   });
  // }

  public fetchMainUrl() {
    return Config.baseUrl + '/idcard/?applicationId=' + Config.applicationId + '&token=' + this.auth.getToken();
  }

  // /**
  //  * Fetch all. Returns the subscriptions.
  //  */
  // public fetchAll() {
  //   let that = this;

  //   return Observable.create((observer: any) => {
  //     let headers = that.auth.createApplicationHeadersWithBearer();

  //     that.http.get(Config.baseUrl + '/quizz', { headers: headers })
  //       .map((res: Response) => res.json())
  //       .subscribe((data) => {
  //         observer.next(data);
  //         observer.complete();
  //         console.log('fetchAll ----->', data);
  //       }, (error: any) => {
  //         observer.error(new Error(error.status));
  //       });
  //   });
  // }

  // /**
  //  * Fetch. Fetch quizz details.
  //  *
  //  * @param $id
  //  */
  // public fetch(id: number) {
  //   let that = this;

  //   return Observable.create((observer: any) => {
  //     let headers = that.auth.createApplicationHeadersWithBearer();

  //     that.http.get(Config.baseUrl + '/quizz/' + id, { headers: headers })
  //       .map((res: Response) => res.json())
  //       .subscribe((data) => {
  //         observer.next(data);
  //         observer.complete();
  //       }, (error: any) => {
  //         observer.error(new Error(error.status));
  //       });
  //   });
  // }

}



// WEBPACK FOOTER //
// ./src/providers/idcard-server/idcard-server.ts